module.exports = __webpack_public_path__ + "static/media/error-compra.6e02ef81.svg";